import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  InputGroup,
  Input,
  InputGroupText,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  Spinner,
} from "reactstrap";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";

import { fullMonthNames } from "../../common/data/monthName";
import LoadingData from "../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import MyThaiDatePick from "../../components/Common/ThaiDatePicker";
import { ConvertDate } from "../Function/ConvertDate";
import { CheckBudgetYear } from "../../pages/Function/CheckBudgetYear"
import SelectOrg from "./selectOrg/selectOrg";
import { date } from "yup/lib/locale";
import NewThaiDatePicker from "../../components/Common/NewThaiDatePicker";
import { ChunkArray } from "../Function/ChunkArray";

const TimeHistoryEmployeeTable = () => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;
  const showLatLong = Number(user_id) === 1220;
  const tableColSpan = showLatLong ? 7 : 5;
  const org_id = GetCookieData("userPosition")[0]?.org_id
  const month = new Date()?.getMonth();

  const [timeHistoryOrg, setTimeHistoryOrg] = useState([]);
  const [entryHistoryOrg, setEntryHistoryOrg] = useState([]);
  const [outHistoryOrg, setOutHistoryOrg] = useState([]);
  const [divisionOrg, setDivisionOrg] = useState(null);
  const [groupOrg, setGroupOrg] = useState(null);
  const [userOrg, setUserOrg] = useState(null);
  const [loadingDatatable, setLoadingDatatable] = useState(true);
  const [hasFilter, setHasFilter] = useState(false)

  const [chunkEntry, setChunkEntry] = useState([]);
  const [data, setData] = useState([]);
  const [entryPagination, setEntryPagination] = useState({
    page: 0,
    totalRows: 0,
    totalPage: 0,
  });

  // const [startDate ,setStartDate] = useState(new Date().setDate(new Date().getDate() - 30))
  const [startDate ,setStartDate] = useState(new Date())
  const [toDate ,setToDate] = useState(new Date())

  const getEntryHistoryByOrgId = async (id, orgDivision = null, orgGroup = null, orgUser = null) => {
    try {
      setLoadingDatatable(true)
      const url = baseURL + "/api/time/history"
      let params = new URLSearchParams({
        // page: entryPagination.page,
        page: 1,
        size: 10000,
        "order[0]": "scan_date",
        "order[1]": "DESC",
        // "filter[budget_year][0]": CheckBudgetYear(),
        date_start: ConvertDate(startDate).toOnlyDate(),
        date_end: ConvertDate(toDate).toOnlyDate(),
        // "filter[entry_exit_status][0]": 0,
        // "filter[entry_exit_status][1]": 1,
      })

      // if (startDate && toDate && hasFilter) {
      //   params.append("date_start", ConvertDate(startDate).toOnlyDate())
      //   params.append("date_end", ConvertDate(toDate).toOnlyDate())
      //   params.delete("filter[budget_year][0]", CheckBudgetYear())
      // }
      const hasOrgGroup = orgGroup !== null && orgGroup !== "" && !(Array.isArray(orgGroup) && orgGroup.length === 0)
      if (hasOrgGroup) {
        if (Array.isArray(orgGroup)) {
            orgGroup.forEach((element,idx) => {
              params.append(`filter[cont_to_id][${idx}]`, element)
            });
        } else {
          params.append("filter[cont_to_id][0]", orgGroup)
        }
      } else if (orgDivision !== null) {
        params.append("filter[cont_to_id][0]", orgDivision)
      }
      if (orgUser !== null) {
        params.append("filter[user_id][0]", orgUser)
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }, params
      }

      const res = await axios.get(url, config)
      setTimeHistoryOrg(res?.data?.result);

      setTimeout(() => {
        setLoadingDatatable(false)
      }, 1500);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getEntryHistoryByOrgId(org_id);
    // fetchInfo()
  }, [])

  useEffect(() => {
    hasFilter ? getEntryHistoryByOrgId(org_id, divisionOrg, groupOrg, userOrg) : getEntryHistoryByOrgId(org_id)
  }, [entryPagination.page])

  // useEffect(() => {
  //   setLoadingDatatable(true)
  //   getEntryHistoryByOrgId(org_id);
  //   setTimeout(() => {
  //     setLoadingDatatable(false)
  //   }, 1500);
  // }, [entryPagination.page]);

  const setDataToEntryAndOutOrg = () => {
    setEntryHistoryOrg([]);
    setOutHistoryOrg([]);
    if (timeHistoryOrg?.length == 0) {
      setChunkEntry([[]]);
      setEntryPagination({
        page: 0,
        totalRows: 0,
        totalPage: 0,
      })
    }
    timeHistoryOrg?.map((item) => {
      if (item?.entry_exit_status !== 1) {
        setEntryHistoryOrg((prev) => [...prev, item]);
      } else {
        setOutHistoryOrg((prev) => [...prev, item]);
      }
      return null;
    });
  };

  useEffect(() => {
    setDataToEntryAndOutOrg();
  }, [timeHistoryOrg]);

  useEffect(() => {
    if (entryHistoryOrg?.length > 0) {
      setChunkEntry(ChunkArray(entryHistoryOrg, 10));
      if (entryPagination?.page === 0) {
          setEntryPagination((prev) => ({
          ...prev,
          page: 1,
          totalRows: entryHistoryOrg?.length,
          totalPage: ChunkArray(entryHistoryOrg, 10)?.length,
        }));
      }
    }
  }, [entryHistoryOrg]);



  const [searchData, setSearchData] = useState();
  const [searchDataTo, setSearchDataTo] = useState();
  const [checkButton, setCheckButton] = useState(true);

  const handleFilter = async () => {
    setHasFilter(true)
      if (arrayPushOrgGroup !== null && arrayPushOrgGroup?.length > 0) {
        await getEntryHistoryByOrgId(org_id, divisionOrg, arrayPushOrgGroup, userOrg);
      } else {
        await getEntryHistoryByOrgId(org_id, divisionOrg, groupOrg, userOrg);
    }
      setEntryPagination((prev) => ({
        ...prev,
        page: 1,
        totalRows: entryHistoryOrg?.length,
        totalPage: ChunkArray(entryHistoryOrg, 10)?.length,
      }))
  }

  const setSearchDate = (e) => {
    setStartDate(e)
    setToDate(e)
  }

  useEffect(() => {
    setEntryPagination((prev) => ({
      ...prev,
      page: prev.page,
      totalRows: entryHistoryOrg?.length,
      totalPage: chunkEntry?.length,
    }))
  }, [chunkEntry])

  const [arrayOrgGroup, setArrayOrgGroup] = useState(null)
  const [arrayPushOrgGroup, setArrayPushOrgGroup] = useState(null)

  useEffect(() => {
   if (arrayOrgGroup !== null) {
    let arrayPop = []
      arrayOrgGroup?.map(i=>(
        arrayPop.push(i?.org_id)
      ))
      setArrayPushOrgGroup(arrayPop)
   }
  }, [arrayOrgGroup])

  useEffect(() => {
   if (groupOrg !== null) {
    setArrayPushOrgGroup(null)
   }
  }, [groupOrg])

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const renderLatLong = (record) => {
    const lat = record?.latitude;
    const long = record?.longitude;
    if (!lat || !long) return "-";
    return (
      <a href={`https://www.google.com/maps?q=${lat},${long}`} target="_blank" rel="noopener noreferrer">
        {lat}, {long}
      </a>
    );
  };

  return (
    <React.Fragment>
      <h4 className="me-3 mb-3" style={{ fontFamily: "Noto Sans Thai" }}>
        การเข้างานของบุคลากรในกลุ่ม/กอง
      </h4>
      <Card
      // style={{ minHeight: "80vh" }}
      >
        <CardBody>
          <Row>
            <Col>
              <Form>
                <SelectOrg setDivisionOrg={setDivisionOrg} setGroupOrg={setGroupOrg} setUserOrg={setUserOrg} arrayOrgGroup={setArrayOrgGroup}/>
                <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
                  <Label className="text-end" md={1} xxl={2}>
                    ค้นหาช่วงวันที่
                  </Label>
                  <Col xs={12} md={4} xl={3}>
                    <InputGroup className={` 
                      ${windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) || (windowSize.width >= 992 && windowSize.width < 1200 )
                        ? "d-flex justify-content-end mb-2" 
                        : ""}`}
                      >
                      <InputGroupText>ตั้งแต่วันที่</InputGroupText>
                      <NewThaiDatePicker rounded="rounded-start-0" value={startDate} setValue={setStartDate} 
                      // maxDate={searchDataTo}
                      placeholderText="วัน/เดือน/ปี" showClearButton={true} />
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={4} xl={3}>
                    <InputGroup className={` 
                        ${windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) || (windowSize.width >= 992 && windowSize.width < 1200 )
                          ? "d-flex justify-content-end mb-2" 
                          : ""}`}
                        >
                      <InputGroupText>ถึงวันที่</InputGroupText>
                      <NewThaiDatePicker rounded="rounded-start-0" value={toDate} setValue={setToDate} minDate={startDate} placeholderText="วัน/เดือน/ปี" showClearButton={startDate !== null} />
                    </InputGroup>
                  </Col>

                  <Col xs={12} md={2} xl={2} className="d-flex justify-content-end">
                    <Button
                      className="w-50"
                      color="success"
                      onClick={() => {
                        handleFilter()
                        if (searchData === "" || searchDataTo === "") {
                          setCheckButton(true)
                        }
                      }}
                    // disabled={checkButton}
                    >
                      <i className="fas fa-search me-2"></i>
                      ค้นหา
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col xxl={12}>
              {/* {!isloading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "350px",
                      }}
                    >
                      <LoadingData />
                    </div>
                  ) : (
                    
                  )} */}
              <FadeIn>
                <div>
                  <Table striped hover style={{ verticalAlign: "middle" }} responsive>
                    <thead className="table-dark">
                      <tr>
                        <th>วันที่</th>
                        <th>ชื่อ-นามสกุล</th>
                        <th className="text-center">เข้างาน</th>
                        {showLatLong && <th className="text-center">พิกัดเข้างาน (Lat, Long)</th>}
                        <th className="text-center">ออกงาน</th>
                        {showLatLong && <th className="text-center">พิกัดออกงาน (Lat, Long)</th>}
                        {/* <th className="text-center">สถานะ</th>*/}
                        <th className="text-center">หมายเหตุ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                      loadingDatatable ?
                        <tr>
                          <td colSpan={tableColSpan}>
                            <LoadingData />
                          </td>
                        </tr>

                        : 
                        chunkEntry[entryPagination?.page - 1]?.length > 0 ?
                          chunkEntry[entryPagination?.page - 1]?.map((item, idx) => {
                            const ScanDate = item?.scan_date?.split("T");
                            const dateEntry = ScanDate[0];
                            const time = ScanDate[1]?.split(".");
                            const timeEntry = time[0];

                            const match = outHistoryOrg?.filter((item2) => item?.scan_date?.split("T")[0] === item2?.scan_date?.split("T")[0] && item?.user_id === item2?.user_id);
                            let scanDate = match[0]?.scan_date
                              ?.split("T")[1]
                              ?.split(".")[0];

                            let note = item?.entry_exit_status === 4 ? item?.entry_exit_status_name : item?.note
                              if (note === '-') {
                                if (match[0]) {
                                  note = match[0]?.note
                                }
                              }
                            
                            return (
                              <tr key={idx}>
                                <td>{ConvertDate(dateEntry).toThaiDateFullDMY()}</td>
                                <td>{item?.user_name}</td>
                                <td className="text-center">
                                  {(item?.entry_exit_status === 0 || item?.entry_exit_status === 5) && timeEntry !== "00:00:00"
                                    ? `${timeEntry} น.`
                                    : "-"}
                                </td>
                                {showLatLong && <td className="text-center">{renderLatLong(item)}</td>}
                                <td className="text-center">
                                  {match[0]?.scan_date !== undefined
                                    ? scanDate + " น."
                                    : "-"}
                                </td>
                                {showLatLong && <td className="text-center">{renderLatLong(match[0])}</td>}
                                {/* <td className="text-center">
                                    {match[0]?.scan_date !== undefined
                                      ? "เต็มวัน"
                                      : item?.entry_exit_status === 2 || item?.entry_exit_status === 3 ? item?.entry_exit_status_name
                                      : item?.entry_exit_status === 4 ? "ขาดงาน" : "ยังไม่ลงเวลาออก"}
                                  </td> */}
                                <td className="text-center">{note}</td>
                              </tr>
                            );
                          })
                          : <tr><td colSpan={tableColSpan} className="text-center" style={{ fontSize: "16px" }}>ไม่มีข้อมูล</td></tr>
                      }


                    </tbody>
                  </Table>
                </div>
              </FadeIn>
            </Col>
          </Row>
        </CardBody>
        {/* {entryHistoryOrg?.length > 0 && ( */}
          <Row
            className="mx-2"
            style={{
              display: "flex",
              alignItems: "end",
            }}
          >
            <Col xxl={4} sm={3} xs={12} className="mb-2">
              <h4>
                <Badge className="badge-soft-primary me-1">
                  ทั้งหมด {entryPagination?.totalRows} รายการ
                </Badge>
              </h4>
            </Col>
            <Col xxl={8} sm={9} xs={12} className="d-flex justify-content-end">
              <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={entryPagination?.page === 1}>
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({ ...prev, page: 1 }))
                    }
                  >
                    หน้าแรก
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={entryPagination?.page === 1}>
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.page - 1,
                      }))
                    }
                  >
                    ย้อนกลับ
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem active>
                  <PaginationLink>
                    {/* {spiner ? <Spinner color="light"/> : `หน้า ${entryPagination?.page} จาก ${entryPagination?.totalPage} `} */}
                    หน้า {entryPagination?.page} จาก {entryPagination?.totalPage} 
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    entryPagination?.page === entryPagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.page + 1,
                      }))
                    }
                  >
                    ถัดไป
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    entryPagination?.page === entryPagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.totalPage,
                      }))
                    }
                  >
                    หน้าสุดท้าย
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        {/* )} */}
      </Card>
    </React.Fragment>
  );
};

export default TimeHistoryEmployeeTable;
